import { formatResponse } from '@frontend/shared/Util.js';

export async function getModelSets() {
  const response = await fetch(`/api/v1/model_sets/`);
  return formatResponse(response);
};

export async function getModelSet(modelSetId, screenSets = []) {
  const screenSetQueryParams = {};
  screenSetQueryParams.values = screenSets.map(screenSet => screenSet.id).join(',');
  const response = await fetch(`/api/v1/model_sets/${modelSetId}?${new URLSearchParams(screenSetQueryParams)}`);
  return formatResponse(response);
};

export async function putModelsToModelSet(modelSetId, modelIds, csrfToken) {
  const response = await fetch(`/api/v1/model_sets/${modelSetId}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: JSON.stringify({
      'model_ids': modelIds,
    }),
  });
  return formatResponse(response);
}

export async function postModelSet(newModelSetName, firmId, csrfToken) {
  const response = await fetch(`/api/v1/model_sets/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: JSON.stringify({
      'name': newModelSetName,
      'firm': firmId,
    }),
  });
  return formatResponse(response);
}

export async function deleteModelSet(modelSetId, csrfToken) {
  const response = await fetch(`/api/v1/model_sets/${modelSetId}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
  });

  // Check if the response has a status indicating success (e.g., 204 No Content or 200 OK)
  if (response.status === 204 || response.status === 200) {
    return {
      ok: true,
      status: response.status,
      data: null, // No data to return, since DELETE usually doesn't return a body
    };
  } else {
    // Handle other response statuses by calling formatResponse
    return formatResponse(response);
  }
}
